import { render } from "./DTooltip.vue?vue&type=template&id=56924a96"
import script from "./DTooltip.vue?vue&type=script&lang=js"
export * from "./DTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__